import React from "react";
import "./CategoryPage.css";
import { ExposedAPI } from "../../apis/ExposedAPI";
import { Icon, LinearProgress, Paper } from "@mui/material";
import { withRouter } from "../../withRouter";
import { Link } from "react-router-dom";
import { CategoriesAccordion } from "../../components/menu/Menu";

import fortitude from "../../images/sectionHeaders/4titude.jpg";
import appareillage from "../../images/sectionHeaders/appareillage.jpg";
import hygsec from "../../images/sectionHeaders/hygiene_securite.jpg";
import mesures from "../../images/sectionHeaders/mesures_physiques.jpg";
import mobilier from "../../images/sectionHeaders/mobilier.jpg";
import verrerie from "../../images/sectionHeaders/verrerie.jpg";
import consommables from "../../images/sectionHeaders/consommables.jpg";
import glassware from "../../images/sectionHeaders/glassware_reduced.jpg";
import { URL_REDIRECT } from "../../constant/url";
import { slugify } from "../../utils/utils";
import Seo from "../../components/seo";
import { categoryMeta } from "../../utils/meta";
import { breadcrumbJsonLd } from "../../utils/jsonld";

class CategoryPage extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      breadcrumbs: [],
      category: null,
    };
  }

  componentDidMount() {
    this.loadCategories(this.props.router.params.categoryName);
  }

  componentWillReceiveProps(nextProps, nextContext) {
    this.loadCategories(nextProps.router.params.categoryName);
  }

  loadCategories(categoryName) {
    this.setState({ breadcrumbs: [], category: null });
    ExposedAPI.getDistantOrStoredCategories()
      .then((categories) => {
        let category = categories.find((cat) => {
          return slugify(cat.label) + "" === categoryName;
        });
        if (!category) {
          this.props.router.navigate("/404", { replace: true });
          return;
        }
        let breadCrumbs = this.getCategoryBreadcrumbs(categories, categoryName);
        this.setState({
          category: category,
          breadcrumbs: breadCrumbs,
        });
      })
      .catch((err) => {
        console.log(err);
      });
  }

  getCategoryBreadcrumbs(categories, categoryName) {
    let category = categories.find((cat) => {
      return slugify(cat.label) + "" === categoryName;
    });
    return [
      {
        id: "c_" + category.id,
        label: category.label,
        link: URL_REDIRECT.categorie + slugify(category.label),
      },
    ];
  }

  render() {
    const { category } = this.state;
    const meta = category ? categoryMeta(category.label, 1, 0) : null;
    const trail = this.state.breadcrumbs.map((item) => ({
      name: item.label,
      path: item.link,
    }));
    return (
      <>
        {category && (
          <Seo
            title={meta.title}
            description={meta.description}
            path={`/categories/${this.props.router.params.categoryName}`}
            jsonLd={breadcrumbJsonLd(trail)}
          />
        )}

        <div style={{ width: "100%", position: "relative" }}>
          {this.state.breadcrumbs.length === 0 && (
            <LinearProgress
              style={{
                width: "100%",
                position: "absolute",
                left: 0,
                top: 0,
                height: 5,
                color: "#0068B3",
              }}
            />
          )}
          <div
            style={{
              width: "100%",
              minHeight: 54,
              display: "flex",
              flexDirection: "row",
              justifyContent: "flex-start",
              alignItems: "center",
              flexWrap: "wrap",
              paddingLeft: 6,
              paddingRight: 12,
            }}
          >
            {this.state.breadcrumbs.map((bc, index) => {
              const BreadcrumbLabel = index === this.state.breadcrumbs.length - 1 ? "h1" : "span";
              return (
                <div
                  key={"bc_" + bc.id}
                  style={{
                    display: "flex",
                    flexDirection: "row",
                    justifyContent: "flex-start",
                    alignItems: "center",
                    marginLeft: 6,
                  }}
                >
                  <Link
                    style={{ textDecoration: "none", paddingBottom: 2 }}
                    to={bc.link}
                  >
                    <BreadcrumbLabel
                      style={{ color: "#222222", fontSize: 14, margin: 0, fontWeight: "normal" }}
                      className={"breadcrumb-link"}
                    >
                      {bc.label}
                    </BreadcrumbLabel>
                  </Link>

                  {index !== this.state.breadcrumbs.length - 1 && (
                    <Icon style={{ fontSize: 18, marginLeft: 6 }}>
                      {"keyboard_arrow_right"}
                    </Icon>
                  )}
                </div>
              );
            })}
          </div>
          {this.state.category && (
            <div className={"category-content-wrapper"}>
              <Paper className={"category-content-paper"}>
                <CategoriesAccordion
                  mode={"category"}
                  categories={[this.state.category]}
                />
              </Paper>
              <Paper
                className={"category-content-image"}
                style={{ backgroundImage: "url(" + this.getImage() + ")" }}
              />
            </div>
          )}
        </div>
      </>
    );
  }

  getImage() {
    switch (Number(this.state.category?.id)) {
      case 2:
        return fortitude;
      case 3:
        return appareillage;
      case 4:
        return hygsec;
      case 5:
        return verrerie;
      case 6:
        return mesures;
      case 7:
        return mobilier;
      case 8:
        return glassware;
      case 9:
        return consommables;
      default:
        return null;
    }
  }
}

export default withRouter(CategoryPage);
